<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <div class="text-h5 font-weight-medium">{{ configTypeTitle }}</div>
      <div class="d-flex justify-end" style="gap: 8px">
        <v-btn outlined @click="onEnableConfig" v-if="disabled">Thiết lập</v-btn>
        <v-btn outlined @click="onDisableConfig" :loading="loading" v-if="!disabled">Huỷ</v-btn>
        <v-btn color="primary" @click="onSave" :loading="loading" v-if="!disabled">Lưu</v-btn>
      </div>
    </div>
    <div class="config-row">
      <div>
        <div class="mb-2 black--text text-body-2">Từ ngày</div>
        <DateTimeInput :value="from" ref="fromInput" :disabled="disabled" />
      </div>
      <div>
        <div class="mb-2 black--text text-body-2">Đến ngày</div>
        <DateTimeInput :value="to" ref="toInput" :disabled="disabled" />
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
import DateTimeInput from '../../../../../components/basic/DateTimeInput.vue'

export default {
  components: {DateTimeInput},
  props: {type: String, grade: String, department: String},
  data: () => ({from: '', to: '', disabled: true, loading: false}),
  computed: {
    ...mapGetters({deadlineItems: 'cvDeadline/items'}),
    configTypeTitle() {
      const newDeptName = this.$helpers.DEPARMENT_DICT[this.department]
      return [this.department, newDeptName].join(' - ')
    },
  },
  methods: {
    ...mapActions({upgrade: 'cvDeadline/upgrade'}),
    onEnableConfig() {
      this.disabled = false
    },
    onDisableConfig() {
      this.disabled = true
    },
    validate() {
      const res = {}
      const from = this.$refs['fromInput'].getData()
      if (typeof from === 'string' && from.length) res['from'] = from
      const to = this.$refs['toInput'].getData()
      if (typeof to === 'string' && to.length) res['to'] = to
      return res
    },
    async onSave() {
      const deadline = this.validate()
      if (Object.keys(deadline).length < 2)
        return this.$alert.error('Vui lòng nhập đầy đủ "Từ ngày" và "Đến ngày" cho "Thời gian nhập điểm"')

      try {
        this.loading = true
        await this.upgrade({
          type: this.type,
          grade: this.grade,
          department: this.department,
          ...deadline,
        })
        this.onDisableConfig()
        this.$alert.success(
          `Thiết lập "Thời gian nhập điểm" cho ${this.configTypeTitle} đối với ${this.grade}, ${this.department} thành công!`,
        )
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    deadlineItems: {
      handler(v) {
        if (Array.isArray(v) && v.length) {
          const found = v.find(i => i.type === this.type && i.department === this.department && i.grade === this.grade)
          this.from = get(found, 'from', '')
          this.to = get(found, 'to', '')
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.config-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 24px;
  grid-row-gap: 0px;
}
</style>